
import VueWithMixins from "@/helpers/mixins";
import RatingsMixin from "./RatingsMixin";

export default VueWithMixins(RatingsMixin).extend({
  name: "rating-viewer"
});
